export const MY_ACCOUNT_FEATURE_LAZY = 'myAccountFeature';
export const MY_ACCOUNT_UI_LAZY = 'myAccountUi';
